import { ComponentNavigationContentProps } from "@organisms/ComponentNavigation/ComponentNavigationContent/ComponentNavigationContent.types"
import { ComponentNavigation } from "@organisms/index"

export default function PopoverSection(props: ComponentNavigationContentProps) {
    return <ComponentNavigation.Content {...props} />
}
